import { render } from "./UeTripsLocalListView.vue?vue&type=template&id=57bfbfd9&scoped=true"
import script from "./UeTripsLocalListView.vue?vue&type=script&lang=js"
export * from "./UeTripsLocalListView.vue?vue&type=script&lang=js"

import "./UeTripsLocalListView.vue?vue&type=style&index=0&id=57bfbfd9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bfbfd9"]])

export default __exports__